export default __webpack_public_path__ + "static/media/USAgreenCard.cbb01767.jpg";